import { SchemerModel } from '../../index'
import {
  SCHEMER_FIELDS
} from './constants'
import {
  quacksLikeADecorator
} from './utils'


export default function createSchemerDecorator(
  handlerFn: (...args: any[]) => any 
) {
  return function decoratorFactory() {
    let decoratorArgs: any[]

    const decorator = function decorate(
      target: SchemerModel,
      propertyName: string
      // descriptor: any
    ) {
      const fieldMetaValue = handlerFn(target, propertyName, ...decoratorArgs)
      return Reflect.metadata(SCHEMER_FIELDS, fieldMetaValue)(
        target,
        propertyName
      )
    }

    // Handle both styles of decorator invocation
    if (quacksLikeADecorator(arguments)) {
      // Invoked as @decorator
      decoratorArgs = []

      return decorator.apply(null, arguments as any)
    } else {
      // Invoked as @decorator(args)
      decoratorArgs = Array.prototype.slice.call(arguments)

      return decorator
    }
  } as Function
}
